module.exports = __webpack_public_path__ + "img/rse_back.7816f872.png";